<template>
  <v-container>
    <campaign-list scope="ultimate" />
  </v-container>
</template>

<script>
import CampaignList from "@/components/admin/campaign/CampaignList.vue";

export default {
  components: { CampaignList },
  metaInfo: { title: "Campanhas" },
};
</script>
